module.exports = __webpack_public_path__ + "static/gba_logo-b50cc7d820eb8311e2af0fc2bfae6c85.png";